import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControl } from '../base.control';

@Component({
  selector: 'sh-primeng-text-input-control',
  templateUrl: './primeng-text-input.control.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PrimengTextInputControl),
      multi: true,
    },
    {
      provide: BaseControl,
      useExisting: forwardRef(() => PrimengTextInputControl),
    },
  ],
  standalone: false,
})
export class PrimengTextInputControl extends BaseControl<string | null> {
  clear() {
    if (this.control) {
      this.control.setValue(null);
      this.control.markAsDirty();
      this.control.markAsTouched();
    } else {
      this.value = null;
    }

    this.emitOnChange(null);
    this.cdRef.detectChanges();
  }
}
